var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnInit } from '@angular/core';
import { Ng1IpInfoService } from '../../shared/ng1/ng1-ip-info.service';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../shared/services/account.service';
import { getPricingSelector } from './pricing-numbers.reducer';
import { Store } from '@ngrx/store';
import TYPES from './get-number.type';
var PricingNumbersComponent = /** @class */ (function () {
    function PricingNumbersComponent(ng1IpInfoService, fb, route, accountService, store, router) {
        this.ng1IpInfoService = ng1IpInfoService;
        this.fb = fb;
        this.route = route;
        this.accountService = accountService;
        this.store = store;
        this.router = router;
        this.regions = [];
    }
    PricingNumbersComponent.prototype.ngOnInit = function () {
        var _this = this;
        var code = this.route.snapshot.paramMap.get('code');
        this.setIsFullyConfigured();
        this.setRegions();
        this.initialNumberCode = !!code ? code.toLowerCase() : this.ng1IpInfoService.getCountry().toLowerCase();
        this.filtersForm = this.fb.group({
            search: [''],
            type: [''],
            region: [''],
            countryCode: [code]
        });
        this.filtersForm.valueChanges.subscribe(function (form) {
            if (form.type === TYPES.FILTER_TYPE.TOLL_FREE && form.region) {
                _this.filtersForm.setValue(__assign({}, form, { region: '' }));
            }
        });
    };
    PricingNumbersComponent.prototype.setIsFullyConfigured = function () {
        var _this = this;
        this.accountService.getAccountConfig().subscribe(function (conf) {
            _this.isFullyConfigured = conf.data;
        });
    };
    PricingNumbersComponent.prototype.setRegions = function () {
        var _this = this;
        this.store.select(getPricingSelector).subscribe(function (pricing) {
            var notUniqueRegions = pricing.filter(function (item) { return item.region; }).map(function (item) { return item.region; });
            _this.regions = Array.from(new Set(notUniqueRegions)).sort();
        });
    };
    Object.defineProperty(PricingNumbersComponent.prototype, "isTollFree", {
        get: function () {
            return this.filtersForm.get('type').value === TYPES.FILTER_TYPE.TOLL_FREE;
        },
        enumerable: true,
        configurable: true
    });
    PricingNumbersComponent.prototype.changeCountry = function (callingInfo) {
        var isValidCountryCode = callingInfo && callingInfo.countryCode;
        var commandsToNavigate = isValidCountryCode
            ? [
                this.isFullyConfigured ? 'get-new-number' : 'get-first-new-number',
                'pricing',
                callingInfo.countryCode.toUpperCase()
            ]
            : [];
        this.router.navigate(commandsToNavigate);
        this.filtersForm.reset({
            search: '',
            type: '',
            region: '',
            countryCode: [callingInfo && callingInfo.countryCode.toLowerCase()]
        });
    };
    return PricingNumbersComponent;
}());
export { PricingNumbersComponent };
